<template>
	<div
		class="close-thread-pill"
		@click="close"
		:aria-label="$t('chat_thread_close')"
		role="button"
	>
		<div v-t="'chat_thread_close'" />
		<CloseIcon class="thread-close" tabindex="0" color="white" />
	</div>
</template>

<script setup>
import { CloseIcon } from '@/icons'
const emit = defineEmits(['close'])
const close = () => emit('close')
</script>

<script>
export default {
	name: 'CloseThreadView',
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.close-thread-pill {
	@include flex-spread;
	padding: 7px 12px 7px 19px;
	border-radius: 5.9px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
	background-color: var(--teal-300);
	width: max-content;
	height: 36px;
	color: #f5f6f8;
	font-size: 16px;
	font-family: Avenir-Heavy;
	position: -webkit-sticky;
	position: absolute;
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
	cursor: pointer;
	z-index: 99;
	.pronto-icon {
		font-size: 22px;
		margin-left: 8px;
	}
}

.close-thread-pill div,
.close-thread-pill svg {
	display: inline-block;
}

.close-thread-pill:hover {
	background-color: darken($pronto-green, 8%);
	box-shadow: 0 2px 4px 0 rgba(45, 92, 120, 0.3);
}
.close-thread-pill:active {
	background-color: darken($pronto-green, 12%);
	box-shadow: none;
}
</style>
